<template>
  <div>
    <el-row type="flex" v-for="(hdr, index) in headers" :key="index">
      <el-autocomplete
        filterable
        v-model="hdr.key"
        placeholder="Key"
        size="mini"
        style="width: 40%; margin-right: 5px"
        :fetch-suggestions="querySearch"
      >
      </el-autocomplete>

      <el-input
        v-model="hdr.value"
        type="text"
        style="width: 40%; margin-right: 5px"
        placeholder="Value"
        size="mini"
      />
      <el-button
        style="float: right"
        size="mini"
        type="text"
        plain
        icon="el-icon-delete"
        circle
        @click="removeHeader(index)"
      />
    </el-row>
    <el-button size="mini" type="primary" plain icon="el-icon-plus" @click="addHeader">
      Add header
    </el-button>
  </div>
</template>

<script>
/**
 * RequestHeaders - Dynamic header key-value pair editor for API requests.
 *
 * @component
 * @description Manages HTTP request headers with autocomplete suggestions for common header names.
 * Displays header pairs as rows with key/value inputs and delete buttons. Includes common headers
 * like Authorization, Content-Type, Accept, etc. in autocomplete suggestions.
 *
 * @prop {Array} headers - Array of {key, value} header objects
 *
 * @fires addHeader - Emitted when "Add header" button clicked
 * @fires removeHeader - Emitted when delete button clicked, passes index
 *
 * @example
 * <RequestHeaders
 *   :headers="api.headers"
 *   @addHeader="onAddHeader"
 *   @removeHeader="onRemoveHeader"
 * />
 */
export default {
  props: ["headers"],
  data() {
    return {};
  },
  methods: {
    querySearch(queryString, cb) {
      var items = [
        "Accept",
        "Accept-Charset",
        "Accept-Encoding",
        "Accept-Language",
        "Access-Control-Request-Method",
        "Access-Control-Request-Headers",
        "Authorization",
        "Cache-Control",
        "Connection",
        "Content-Length",
        "Content-Type",
        "X-Client-Id",
        "x-Gateway-APIKey",
        "X-Requested-With",
        "x-api-key",
      ];
      const results = queryString
        ? items.filter((i) => i.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        : items;
      cb(results.map((i) => ({ label: i, value: i })));
    },
    addHeader() {
      this.$emit("addHeader");
    },
    removeHeader(index) {
      this.$emit("removeHeader", index);
    },
  },
};
</script>

<style></style>
